import React, { useEffect, useState } from 'react';
import Button from 'components/Buttons/Button';
import { useCountSelectedSeances } from './atom';
import { hasSimpleMapping } from 'components/EntitiesSelectorModals/ClassroomsMappingModal/hasSimpleMappping';
import 'twin.macro';
import {
  ClassroomsMapping,
  ClassroomMapping,
  NO_COPY,
} from 'components/EntitiesSelectorModals/ClassroomsMappingModal/ClassroomsMapping';
import Popover from 'components/Popover';
import { XMarkIcon as X } from '@heroicons/react/24/outline';
import { School } from 'types/school';
import { Schoolyear } from 'types/schoolyear';
import { ClipboardDocumentIcon as ClipboardCopy } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { useClassroomsCopyEvents } from './useClassroomsCopyEvents';

interface Props {
  onSubmit: (v: ClassroomMapping[]) => void;
  disabled?: boolean;
  loading?: boolean;
  ctaTitle?: (nbOfSelectedSeances?: number) => any;
  srcSchool?: School;
  destSchool?: School;
  srcSchoolyear?: Schoolyear;
  destSchoolyear?: Schoolyear;
}

export function SubmitButton(props: Props) {
  const count = useCountSelectedSeances();
  const { srcSchoolyear, destSchoolyear, destSchool, srcSchool } = props;

  const { t } = useTranslation(['common', 'cahierJournal']);

  const srcClassrooms = useClassroomsCopyEvents({
    schoolId: srcSchool?.id,
    schoolyearId: srcSchoolyear?.id,
  });

  const destClassrooms = useClassroomsCopyEvents({
    schoolId: destSchool?.id,
    schoolyearId: destSchoolyear?.id,
  });

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const [classroomMapping, setClassroomMapping] = useState<ClassroomMapping[]>(
    [],
  );
  useEffect(() => {
    setClassroomMapping(
      (srcClassrooms || []).map((c, i) => {
        if (!destClassrooms || destClassrooms.length < i + 1) {
          return {
            from: c.id,
            to: NO_COPY,
          };
        }
        return {
          from: c.id,
          to:
            (destClassrooms || []).length > i ? destClassrooms[i].id : NO_COPY,
        };
      }),
    );
  }, [JSON.stringify(destClassrooms), JSON.stringify(srcClassrooms)]);
  const { onSubmit, loading, disabled } = props;
  const submitLabel =
    props.ctaTitle && !disabled
      ? props.ctaTitle(count)
      : t('common:buttons.copy');
  if (!hasSimpleMapping(srcClassrooms || [], destClassrooms || [])) {
    return (
      <Popover
        placement="top"
        portal
        open={isPopoverOpen}
        offsetInPx={10}
        onClickOutside={() => {}}
      >
        <Popover.Button
          large
          intent="primary"
          disabled={disabled || loading}
          loading={loading}
          rightIcon={ClipboardCopy}
          onClick={() => {
            if (disabled || loading) {
              return;
            }
            if (!isPopoverOpen) {
              setIsPopoverOpen(true);
              return;
            }
            return onSubmit(classroomMapping);
          }}
        >
          {isPopoverOpen ? t('common:buttons.validate') : submitLabel}
        </Popover.Button>
        <Popover.Panel size="xl" tw="relative">
          <div tw="p-4">
            <div tw="mb-4">
              {t(
                'cahierJournal:copyEventsToAnotherDayModal.classroomsMatching',
              )}
            </div>
            <div tw="mb-4" data-testid="classroomMapping">
              <ClassroomsMapping
                srcClassrooms={srcClassrooms || []}
                destClassrooms={destClassrooms || []}
                value={classroomMapping}
                onChange={setClassroomMapping}
              />
            </div>
            <div tw="absolute top-1 right-1 ">
              <Button
                minimal
                icon={X}
                onClick={() => setIsPopoverOpen(false)}
              />
            </div>
          </div>
        </Popover.Panel>
      </Popover>
    );
  }
  return (
    <Button
      large
      intent="primary"
      disabled={disabled}
      loading={loading}
      rightIcon={ClipboardCopy}
      onClick={() => onSubmit(classroomMapping)}
    >
      {submitLabel}
    </Button>
  );
}
